import React, { FC } from 'react';
import type {
    AddressSuggestionProps,
} from '~/src/components/common-components/dropdown-address-item/dropdown-address-item.types';
import * as Styled from './dropdown-address-item.styles';

/**
 * Used in Module Federation
 */
const DropdownAddressItem: FC<AddressSuggestionProps> = ({
    city,
    fullName,
    block,
    flat,
    street,
    house,
    postcode,
    country,
    region,
}) => {

    if (fullName) {
        return (
            <Styled.AddressSuggestion>
                {fullName}
            </Styled.AddressSuggestion>
        );
    }

    return (
        <Styled.AddressSuggestion>
            {country && <>{country},&nbsp;</>}
            {region && <>{region},&nbsp;</>}
            {postcode && <>{postcode},&nbsp;</>}
            {city && <>{city},&nbsp;</>}
            {street && <>ул. {street},&nbsp;</>}
            {house && <>д. {house},&nbsp;</>}
            {flat && <>кв. {flat},&nbsp;</>}
            {block && <>корпус {block}</>}
        </Styled.AddressSuggestion>
    );
};

export default DropdownAddressItem;